export var SKILLS_API = {
    domains: '/api/teachers/success/groups/:groupId/domains',
    groupSkills: '/api/teachers/success/groups/:groupId/rating',
    skillsInfo: '/api/teachers/success/groups/:groupId/info',
    studentSkills: '/api/teachers/success/students/:studentId/details',
};
